import { render, staticRenderFns } from "./RgSearchJiraTicket.vue?vue&type=template&id=1fb2839a&"
import script from "./RgSearchJiraTicket.vue?vue&type=script&lang=js&"
export * from "./RgSearchJiraTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports